import { MessageCircle } from "lucide-react";
import { SITE } from "../data/site";

const WhatsAppFloat = () => (
    <a
        href={SITE.whatsappPrefill}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat with ALBL Communications on WhatsApp"
        data-testid="mobile-whatsapp-floating-button"
        className="fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-[#25D366] text-[#0D131F] rounded-full shadow-xl shadow-black/20 px-4 py-3 sm:px-5 sm:py-3.5 btn-sharp"
    >
        <MessageCircle className="h-5 w-5" />
        <span className="text-xs font-bold tracking-[0.1em] uppercase">WhatsApp</span>
    </a>
);

export default WhatsAppFloat;
